/* 
  利用开始日期和结束日期计算出中间的所有日期
  create by 李智惠 2021-11-05
*/
function computeDates(dateRange) {
  this.searchForm.dates = [];
  var bDate = dateRange[0]; // 开始时间
  var eDate = dateRange[1]; // 结束时间
  // 创建日期对象，日期为开始时间 
  var objDate = new Date(bDate);
  var iDays = DateDiff(bDate, eDate);
  for (var i = 0; i <= iDays; i++) {
    var year = objDate.getFullYear();
    var month = objDate.getMonth() + 1; // getMonth返回的月份是从0开始的，因此要加1
    var date = objDate.getDate();
    this.searchForm.dates.push(year + "-" + month + "-" + date)
    objDate.setDate(objDate.getDate() + 1);
  }

  // 计算天数的函数
  function DateDiff(beginDate, endDate) { // beginDate和endDate都是yyyy-MM-dd格式
    var arrbeginDate, date1, date2, arrendDate, iDays;
    arrbeginDate = beginDate.split("-");
    date1 = new Date(arrbeginDate[1] + '-' + arrbeginDate[2] + '-' + arrbeginDate[0]); // 转换为yyyy-MM-dd格式
    arrendDate = endDate.split("-");
    date2 = new Date(arrendDate[1] + '-' + arrendDate[2] + '-' + arrendDate[0]);
    iDays = parseInt(Math.abs(date1 - date2) / 1000 / 60 / 60 / 24); // 转换为天数 
    return iDays;
  }
}
export default computeDates;